/**
 * Shared constants for the records list-view toolkit. `OperationType` and the
 * empty-state copy are operation-agnostic and consumed by Applications, Work
 * Orders, and Invoices alike; relocated here out of
 * `screens/Applications&WorkOrders/{RouteAdmin,Components/Constants}`.
 */

export enum OperationType {
  APPLICATION,
  WORK_ORDER,
  // INVOICE is additive: invoices reuse the shared ListView/DetailPanel/FilterDrawer
  // shell but never route through RouteAdmin, so it is intentionally NOT added to the
  // `components`/`formikProps` maps there (see specs/001-invoices-redesign, AD-2).
  INVOICE,
  // PLAN is additive for the same reason: Plans reuses the shared ListView/
  // DetailPanel shell but has its own PlansPage/PlanViewGuard, not RouteAdmin
  // (see specs/CWFWEB-9865-plans-ui-upgrade, research.md's "OperationType
  // extension for Plans" decision).
  PLAN
}

// No Filter and Search results
export const EMPTY_STATE_CONTENT = {
  [OperationType.APPLICATION]: {
    search: {
      title: 'No Applications Found',
      content: 'Change the selected season or try a different search.'
    },
    filter: {
      title: 'No Applications Found',
      content: 'Clear or adjust filter selections to see Applications.'
    }
  },
  [OperationType.WORK_ORDER]: {
    search: {
      title: 'No Work Orders Found',
      content: 'Change the selected season or try a different search.'
    },
    filter: {
      title: 'No Work Orders Found',
      content: 'Clear or adjust filter selections to see Work Orders.'
    }
  },
  [OperationType.INVOICE]: {
    search: {
      title: 'No Invoices Found',
      content: 'Change the selected season or try a different search.'
    },
    filter: {
      title: 'No Invoices Found',
      content: 'Clear or adjust filter selections to see Invoices.'
    }
  },
  [OperationType.PLAN]: {
    search: {
      title: 'No Plans Found',
      content: 'Change the selected season or try a different search.'
    },
    filter: {
      title: 'No Plans Found',
      content: 'Clear or adjust filter selections to see Plans.'
    }
  }
};
